/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowNarrowUp = createReactComponent("outline", "arrow-narrow-up", "IconArrowNarrowUp", [["path", { "d": "M12 5l0 14", "key": "svg-0" }], ["path", { "d": "M16 9l-4 -4", "key": "svg-1" }], ["path", { "d": "M8 9l4 -4", "key": "svg-2" }]]);

export { IconArrowNarrowUp as default };
//# sourceMappingURL=IconArrowNarrowUp.mjs.map
